import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {ChosenPluginsModule} from '../chosen-plugins/chosen-plugins.module';
import { ImageCropperPluginsComponent} from './image-cropper-plugins.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ChosenPluginsModule
  ],
  exports: [ImageCropperPluginsComponent],
  declarations: [ImageCropperPluginsComponent]
})
export class ImageCropperPluginsModule { }



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/components/image-cropper-plugins/image-cropper-plugins.module.ts